import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WebIcon from '@material-ui/icons/Web';
import TemplateSettings from './TemplateSettings';
import TemplateAnalytics from './TemplateAnalytics';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  icon: {
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  section: {
    marginBottom: theme.spacing(3),
  },
}));

export default function TemplatesPage({ userId }) {
  const classes = useStyles();

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Box className={classes.header}>
        <WebIcon className={classes.icon} />
        <Box>
          <Typography variant="h4">Public Page Templates</Typography>
          <Typography variant="body1" color="textSecondary">
            A/B test different homepage designs and measure which one converts better.
          </Typography>
        </Box>
      </Box>

      <Box className={classes.section}>
        <TemplateSettings userId={userId} />
      </Box>

      <Box className={classes.section}>
        <TemplateAnalytics userId={userId} />
      </Box>
    </Container>
  );
}

TemplatesPage.propTypes = {
  userId: PropTypes.string,
};
